<template>
  <div
    class="div-container"
  >
    <div
      v-if="section === 'versions' && preprocess"
      style="background-color: white; min-height: 100vh;"
    >
      <b-row style="padding-bottom:10px">
        <b-col md="6">
       
          <h3>Version List</h3>
        </b-col>
        <b-col md="6">
          <b-button
            style="float:right"
            variant="gradient-primary"
            class="rounded"
            size="sm"
            @click="section = 'add_version'"
          >
      
          
            ADD NEW VERSION
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
	<div class="table-scroll-x">
          <b-table
            v-if="preprocess"
            id="versionsTable"
            :fields="fields"
            :items="versions"
            responsive
            striped
            class="mb-0"
            hover
            :busy="isBusy"
            select-mode="single"
           

          >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
             
            </div>
          </template>
          

            <template
              #cell(markers)="data"
              style="text-align:center"
              :style="{ 'background-color': parent_versions.includes(Number(data.item.id)) ? '#ccc' : '' }"
            
            
            >
            
          
              <b-badge 
                v-for="(marker, index) in JSON.parse(data.value)"
                :key="index"
                class="m-50"
                
                :variant="(marker.marker_type === 'Phenotypic')? 'light-success' : (marker.marker_type === 'Functional')? 'light-info' : 'light-warning'"
              >
            
                {{ marker.marker_id }} 
              </b-badge>
            </template>
            <template
            >

            </template>
            <template
              #cell(id)="data"
              style="text-align:center"
       

             
            >
              <b-overlay
                :show="inTask.includes(data.value)"
                opacity="1"
                spinner-variant="primary"
                spinner-small
                rounded="md"
                
              >
                <template
                  v-slot:overlay

                >
                  <div style="display:flex; align-items: center; flex-direction: row;">
                    <b-spinner
                      small
                      type="grow"
                    />
                    <div class="ml-2">
                      <small v-if="progress(data.value) !== null">Last Update:<br> {{ progress(data.value) }}</small>
                    </div>
                  </div>
                </template>
                <b-button
                  variant="gradient-danger"
                  class="btn-icon rounded"
                  size="sm"
                  @click="delVersion(data.value)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
                <b-button
                  variant="gradient-primary"
                  class="rounded ml-50"
                  size="sm"
                  @click="(hasImages(data.value)) ? preClustering(data.value) : clustering(data.value)"

                >
                  Clustering 
                </b-button>
                <b-button
                  
                  :disabled="!hasImages(data.value)"
                  variant="gradient-success"
                  class="rounded ml-50"
                  size="sm"
                  @click="selectVersion(data.value)"
                >
             
               
                  Go to annotations
                </b-button>
                <b-button
                  :disabled="!hasImages(data.value) || data.item.display_split != 3"
                  variant="gradient-success"
                  class="rounded ml-50"
                  size="sm"
                  @click="addNode(data.value)"
                >
                  Do split 
                </b-button>

              </b-overlay>
            </template>
            <template
              #cell(status)="data"
               >
            <div    :style="{ 'font-weight': parent_versions.includes(Number(data.item.id)) ? 'bold' : '' }">
              {{getTaskStatus(data)}}
            
            </div>
          </template>
          <template
              #cell(title)="data"
               >
            <div   :style="{ 'font-weight': parent_versions.includes(Number(data.item.id)) ? 'bold' : '' }">
              {{data.value}} 
            
            </div>
          </template>
          <template
              #cell(created_at)="data"
               >
            <div    :style="{ 'font-weight': parent_versions.includes(Number(data.item.id)) ? 'bold' : '' }">
              {{data.value}} 
            
            </div>
          </template>

          <template
              #cell(user)="data"
               >
            <div   :style="{ 'font-weight': parent_versions.includes(Number(data.item.id)) ? 'bold' : '' }">
              {{data.value}} 
            
            </div>
          </template>

          </b-table>
</div>
        </b-col> </b-row>
    </div>
    <div
      v-if="section === 'add_version' && preprocess"
      class="div-container"
    >
      <b-row style="padding-bottom:10px">
        <b-col md="6">
          <h3>Add New Version</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <b-form-group
            label="Version Title"
            label-for="versionTitle"
          >
            <b-form-input
              id="versionTitle"
              v-model="versionTitle"
              placeholder="Enter Version Title"
              :state="(versionTitle.trim().length > 0) ? true : ((versionTitle.length === 0) ? null : false)"
            />
          </b-form-group>
          <b-form-group
            label="Description"
            label-for="versionDescription"
          >
            <b-form-textarea
              id="versionDescription"
              v-model="versionDescription"
              placeholder="Textarea"
              rows="3"
            />
          </b-form-group>
          <b-alert
            v-model="errors"
            v-height-fade.appear
            variant="danger"
            dismissible
          >
            <h4 class="alert-heading">
              There are some errors
            </h4>
            <div class="alert-body">
              <ul>
                <li
                  v-for="(error, index) in errorlist"
                  :key="index"
                >
                  {{ error }} 
                </li>
              </ul>
            </div>
          </b-alert>
          <div class="button-space">
            <b-button
              variant="outline-danger"
              class="btn-icon rounded mt-2 mb-0"
              size="md"
              @click="cancelVersion"
            >
              CANCEL
            </b-button>
            <b-button
              variant="outline-success"
              class="btn-icon rounded mt-2 mb-0"
              size="md"
              @click="saveVersion"
            >
           
              SAVE
            </b-button>
          </div>
        </b-col>
        <b-col md="9">
          <div class="markerList">
            <div>
             
              <h6>Non included markers</h6>

              <div
                :list="nonIncluded"
                :group="{name:'tags'}"
                class="mb-1 marker-selectable"
              >
                <b-badge
                  v-for="(marker, index) in nonIncluded"
                  :key="index"
                  class="m-50"
                  style="cursor:pointer"
                  :variant="(marker.marker_type === 'Phenotypic')? 'light-success' : (marker.marker_type === 'Functional')? 'light-info' : 'light-warning'"
                  @click="include(marker, index)"
                >
                  {{ marker.marker_id }}
                </b-badge>
              </div>
            </div>

            <!-- add tag -->
            <div>
              <h6>Included markers</h6>

              <div
                :list="included"
                :group="{name: 'tags'}"
                class="mb-1 marker-selectable"
              >
                <b-badge
                  v-for="(marker, index) in included"
                  :key="index"
                  class="m-50"
                  style="cursor:pointer"
                  :variant="(marker.marker_type === 'Phenotypic')? 'light-success' : (marker.marker_type === 'Functional')? 'light-info' : 'light-warning'"
                  @click="noinclude(marker, index)"
                >
                  {{ marker.marker_id }}
                </b-badge>
              </div>
            </div></div>
          <div>
            <b-badge
              class="m-50"
              variant="light-success"
            >
              Phenotypic
            </b-badge>
            <b-badge
              class="m-50"
              variant="light-info"
            >
              Funtional
            </b-badge>
            <b-badge
              class="m-50"
              variant="light-warning"
            >
              NA
            </b-badge>
          </div>
        </b-col></b-row></div>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  BRow, BCol, BBadge, BTable, BButton, BFormInput, BFormTextarea, BFormGroup, BAlert, BOverlay, BSpinner,
} from 'bootstrap-vue'
import NewParentNode from './downstream/NewParentNode.vue'
import NewChildNode from './downstream/NewChildNode.vue'
import store from '@/store/index'
import axios from 'axios'
import { heightFade } from '@core/directives/animations'
import Results from './tabs/project/downstream/Results.vue'
import Swal from 'sweetalert2'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    BRow,
    Results,
    BCol,
    BBadge,
    BTable,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BAlert,
    BOverlay,
    BSpinner,
    NewParentNode,
    NewChildNode
  },
  directives: {
    'height-fade': heightFade,
  },
  props: {
    parent_version_id:{
      required: true,
          type: Array,
          default: [],
    },
    selected: {
      required: true,
      type: Boolean,
    },
    node_id: {
      required: false,
      type: Number,
      default: 0
    },
    project_id: {
      required: false,
      type: Number,
      default: 0
    },
    preprocess: {
      required: true,
      type: Boolean,
    },
    status: {
      required: true,
      type: [Object, Array, String, null],
    },
  },
  data() {
    return {
      section: 'versions',
      nonIncluded: [],
      included: [],
      computing: [],
      computed: true,
      process: false,
      fields: [
        { key: 'idv', label: 'ID', sortable: false },
        { key: 'title', label: 'Title', sortable: true },
        { key: 'markers', label: 'Included markers', sortable: true },
        { key: 'created_at', label: 'Created At', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'id', label: '', sortable: false },
    
      ],
      versions: [],
      versionImages: [],
      versionTitle: '',
      versionDescription: '',
      errors: false,
      errorlist: [],
      username: '',
      tasktype_status: [],
      inTask: [],
      isBusy:true,
      timerVersions:null,
      parent_versions:[]
    }
  },
  destroyed() {
    clearInterval(this.timerVersions)
  },
  beforeDestroy() {
    clearInterval(this.timerVersions)
  },
  watch: {
    status() {
      if (this.status.tasktype_status.length > 0) {
        this.tasktype_status = this.status.tasktype_status
      } else if (this.tasktype_status.length > 0) {
        this.tasktype_status = []
      }
    },
    tasktype_status() {
      this.checkInTask()
      if (this.tasktype_status.length === 0) {
        this.getVersions()
        this.process = false
      }
    },
  },
  created(){
   
    
   // this.getVersions()
  },
  beforeDestroy(){
    clearInterval(this.timerVersions)

  },
  beforeClose(){
   clearInterval(this.timerVersions)

  },
 
  async mounted() {
    
    console.log("PAERNT VERSION ID", this.parent_version_id, this.parent_version_id[0], this.node_id)
    try{
      
     const parent_versions = this.parent_version_id[0][(this.node_id)]
     if(parent_versions != null && parent_versions != undefined){
      this.parent_versions = parent_versions
     }
    //this.parent_versions = []
    }catch{
      this.parent_versions = []
    }
    console.log("PAREN", this.parent_versions)
    await this.getMarkers()
    this.getVersions()
    this.timerVersions = setInterval(() => {
     
      this.getVersions()
   
    }, 1000)
    this.username = (`${store.state.user.userdata.name} ${store.state.user.userdata.lastname}`).trim()
  },
  methods: {
    unMount(){
    clearInterval(this.timerVersions)
  },
    getTaskStatus(data){

      var time_update = data.item.time_update
      var str_vr = ''
      if(this.parent_versions.includes(data.item.id)){
        str_vr = ' (Split version)'
      }
      if(data.item.display_split == 10){
        return 'Custer conflicts. Please, go to annotations and check selected clusters.  ' + str_vr
      }
      if(data.item.do_clustering ==1 && this.hasImages(data.item.id) == false){
        if (time_update == null || time_update == undefined){
          return 'In queue ...' + str_vr
        }
        return 'Doing computation. \n' + data.item.time_update + str_vr
      }
      if(data.item.do_clustering ==1 && this.hasImages(data.item.id) == true){
       
          return 'Show results.' + str_vr
        
     
      }
      if(time_update != undefined && time_update != null){
        return 'Doing computation. \n' + data.item.time_update + str_vr
      }
      if(data.item.display_split == 1 || this.hasImages(data.item.id == false)){
        return 'Done' + str_vr
      }

     if(data.item.do_clustering == 1){
        if (time_update == null || time_update == undefined){
          return 'In queue ...' + str_vr
        }
        return 'Doing computation. \n' + data.item.time_update + str_vr
      }
     
      if(data.item.do_clustering == 0){
        return 'Pending to do clustering' + str_vr
      }
      if(data.item.do_clustering == 2){
        return 'Clustering done'  + str_vr
      }
    },
    clearData(){
    //  clearInterval(this.timerVersions)
    },
    clusterProgres(data){
      return 'Clustering'
    },
    show_results(version ){
      const { project_id } = this
      const node_id = this.node_id
      
      
      const res = new Vue({
        ...Results,
        parent: this,
        propsData: { version, taskStatus:[], node_id: node_id, project_id: project_id },
      }).$mount()
      this.$swal({
        html: res.$el,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        confirmButtonText: 'Save',
        width: '90%',
        allowEscapeKey: false,
        allowEscapeKey: false,
        beforeClose: () => {
    return new Promise(async (resolve) => {
      // Ejecutar la lógica de handleClose y obtener la variable
      const variableFromResults = res.handleClose();

      // Mostrar un pop-up de advertencia antes de cerrar el modal
      allowClose = await this.$swal({
        title: '¡Advertencia!',
        text: '¿Estás seguro de que quieres cerrar?',
        icon: 'warning',
        buttons: ['Cancelar', 'Sí, cerrar'],
      });

      // Si el usuario elige "Cancelar", no permitir cerrar el modal
      if (!allowClose) {
        resolve(false);
      }

      // Hacer algo con la variable obtenida
      console.log('Variable del componente Results:', variableFromResults);

      // Permitir cerrar el modal después de la advertencia
      resolve(true);
    });
  },
        onOpen: () => {
          this.unMount()
          // Agrega un listener para el evento keydown en el elemento modal
          const modalElement = document.querySelector('.swal2-modal');
          modalElement.addEventListener('keydown', (event) => {
            // Evita el cierre del modal al presionar la tecla "ESC"
            if (event.key === 'Escape') {
              const index = res.returnIndex()
              console.log("INDEX IS", index)
              if(index == null){
                console.log("CLOSE")
                //this.$swal.close()
                event.stopImmediatePropagation();

              }else{
                event.stopImmediatePropagation();
                res.escape_pressed()

              }
              
            }
          });
        },

      }).then(async result => {
          if (result.dismiss == 'close') {
            const opti = res.handleClose();
            console.log("Le doy aceerrrar", opti)
            if(opti){
              console.log("Que nos salga el errror!!")
              event.stopImmediatePropagation();
            }
            
          }
        })
    },
    async splitVersion(val){
      var clusters = []
      
      await axios.get(`${url}:${port}/downstream-final-clusters/${val}`, { headers }).then(async result => {
        if (result) {
         
          clusters = result.data.clusters
         /* var clust2 = clust[0].annotation
          clust = JSON.parse(clust2)
          for(var i=0;i<clust.length;i++){
            if(clust[i].annotated == 1){
              clusters.push(clust[i].annotation)

            }
         
          }*/
     
          
        }
      
      })
      var data = { parent_version_id: val, parent_node_id: this.node_id, clusters: clusters, project_id: this.project_id}
      const { id} = this
      const node_id = this.node_id
      const newParent = new Vue({
        ...NewChildNode,
        parent: this,
        propsData: {data: data},
      }).$mount()
      this.$swal({
        html: newParent.$el,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        confirmButtonText: 'Save',
        width: '60%',

      }).then(async result => {
          if (result.dismiss == undefined) {
        
          }
        })

    },
    async addNode(val){
      //get parent clusters

      if(this.parent_versions.length > 0 && !this.parent_versions.includes(val)){
        Swal.fire({
          title: 'Are you sure?',
          text: "Attention, if you split another annotation version, the nodes corresponding to the current lower hierarchies will be lost.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          console.log("result", result)
          if (result.isConfirmed) {
            this.remove_children()
            this.splitVersion(val)
          }
      })
      }
      else{
        this.splitVersion(val)
      }
    },
    
    progress(version) {
      const tasks = ['10.2', '10.3', '10.4']
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.tasktype_status.length; index++) {
        const element = this.tasktype_status[index]
        if (element.json.version_id === version && tasks.includes(element.json.task_type)) {
          return (element.progress !== null) ? element.progress.timestamp : null
        }
      }
      return null
    },
    checkInTask() {
      const intask = []
      const tasks = ['10.2', '10.3', '10.4']
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.tasktype_status.length; index++) {
        const element = this.tasktype_status[index]
        if (tasks.includes(element.json.task_type)) {
          intask.push(element.json.version_id)
          this.process = true
        }
      }
      this.inTask = intask
    },
    preClustering(version) {
      this.$swal({
        title: 'Are you sure?',
        text: "All annotation data and digital reconstruction will be deleted. You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'YES',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.clustering(version)
        }
      })
    },
   async  remove_children() {
      const node_id = this.node_id
      
    
        const data= await axios.post(`${url}:${port}/remove-children/${node_id}`, {  }, { headers })
        console.log("REMOVE CHILDREN", data)
      
    },
    clustering(version) {
      this.process = true
      const id = this.project_id;
      
      if (version !== null) {
        this.computing.push(version)
        axios.post(`${url}:${port}/downstream-clustering/${id}`, { version, user_id: 1 }, { headers })
      }
    },
    hasImages(id) {
      return (this.versionImages.includes(id))
    },
    include(marker, index) {
      this.included.push(marker)
      this.nonIncluded.splice(index, 1)
    },
    noinclude(marker, index) {
      this.nonIncluded.push(marker)
      this.included.splice(index, 1)
    },
   async getMarkers() {
      
     
      const id = this.project_id
      //const id = 32;
      console.log('getMarkers')
      await axios.get(`${url}:${port}/downstream-markers/${id}`, { headers }).then(result => {
        if (result) {
          this.included = []
          this.nonIncluded = (result.data.markers.non_included)
        }
      
      })
    },
    getVersions() {
      this.computing = []
      
        const id= this.project_id
        var  node_id = this.node_id
        try{
          if( node_id == undefined){
            node_id = 0
            
          }
        }catch{
          node_id = 0
        }
       
      //const id = 32;
      axios.get(`${url}:${port}/downstream-versions/${id}/${node_id}`, { headers }).then(async result => {
        if (result) {
          const versions = []
       
          result.data.versions.forEach(element => {
            // eslint-disable-next-line no-param-reassign
            element.idv = element.id
            versions.push(element)
          })
          this.versions = versions
          console.log("VERSIONS", versions)
          this.isBusy = false;
          //this.section = 'versions'
          // eslint-disable-next-line no-plusplus
          for (let index = 0; index < this.versions.length; index++) {
            const element = this.versions[index]
            if (element.hasImages) {
              this.versionImages.push(element.id)
            }
          }
        }
      })
    },
    cancelVersion() {
      if (this.errors) {
        setTimeout(this.changeSection, 500)
      } else {
        this.changeSection()
      }
      this.errors = false
      this.errorlist = []
       this.getMarkers()
      this.versionTitle = ''
      this.versionDescription = ''
    },
    changeSection() {
      this.section = 'versions'
    },
    saveVersion() {
      this.errors = false
      this.errorlist = []
      const versionTitle = this.versionTitle.trim()
      let allCorrect = true
      if (versionTitle.length === 0) {
        allCorrect = false
        this.errorlist.push('Version Title is requered')
      }
      if (this.included.length === 0) {
        allCorrect = false
        this.errorlist.push('An included Marker is required')
      }
      if (allCorrect) {
       
        const id= this.project_id;
        const node_id = this.node_id;
        const title = this.versionTitle
        const description = this.versionDescription
        const user = this.username
        const markers = this.included
        axios.post(`${url}:${port}/downstream-versions/${id}/${node_id}`, {
          title, description, markers, user,
        }, { headers }).then(async result => {
          if (result) {
            
            //console.log("Envío result", result)
            await this.getVersions()
            this.section = 'versions'
            this.included = []
            this.nonIncluded = result.data.markers.non_included
            this.errors = false
            this.errorlist = []
            this.versionTitle = ''
            this.versionDescription = ''
            
          }
        })
      } else {
        this.errors = true
      }
    },
    delVersion(id) {
      // eslint-disable-next-line no-restricted-globals, no-alert
      if (confirm('Selected version will be deleted')) {
        axios.delete(`${url}:${port}/downstream-versions/${id}`, { headers }).then(result => {
          if (result) {
            this.getVersions()
          }
        })
      }
    },
    selectVersion(id) {
      const selVersion = this.versions.find(version => version.id === id)
      this.show_results(selVersion)
      //this.$emit('selversion', selVersion)
    },
  },
}
</script>
<style>
.table-with-dark-background {
  background-color: #ccc; /* Ajusta el color de fondo oscuro según tus necesidades */
  color: white; /* Ajusta el color del texto según tus necesidades */
}
.div-container{
min-height: calc(100vh - 325px);
font-size:15px !important;
}
#versionsTable td[aria-colindex="2"],
#versionsTable td[aria-colindex="3"]{
  min-width: 250px
}
#versionsTable td[aria-colindex="5"]{
  width: 201px
}
#versionsTable td[aria-colindex="6"]{
  width: 400px
}
#versionsTable .spinner-border {
    display: inline-block;
    color: #008380;
    width: 5rem;
    height: 5rem;
    vertical-align: text-bottom;
}
.button-space{
   display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-start;align-items: center;
}
.button-space button{
    margin-right: 15px;
}
.markerList{
  display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    align-items: stretch;
    align-content: center;
}
.markerList div{
  flex: 0 0 50%;
}
.markerList h6{
  margin-left: 10px;
}
.table-scroll-x {
width: 100%;
overflow-x: auto;
overflow-y: hideen;
}
#versionsTable table{
min-width: 1200px;
table-layout:fixed;
}
#versionsTable th,
#versionsTable td {
  white-space: nowrap;
}

/* Columnas concretas */
#versionsTable td[aria-colindex="2"],
#versionsTable td[aria-colindex="3"] {
  min-width: 250px;
}

#versionsTable td[aria-colindex="5"] {
  min-width: 200px;
}

#versionsTable td[aria-colindex="6"] {
  min-width: 380px;
}

</style>
<style scoped>
.marker-selectable{
  background: whitesmoke;
  padding: 10px;
  margin: 10px;
  height: calc(100% - 30px)
}
</style>
